/** Skeleton placeholders shown while spoken content is applied to a task note. */
export default function NoteApplyingSkeleton() {
  return (
    <div className="animate-pulse space-y-4 py-2" aria-busy="true" aria-label="Applying recording">
      <div className="h-16 w-3/4 rounded-xl bg-gray-200" />
      <div className="flex gap-4">
        <div className="flex flex-1 flex-col gap-2 pt-1">
          <div className="h-2.5 w-full rounded bg-gray-200" />
          <div className="h-2.5 w-5/6 rounded bg-gray-200" />
          <div className="h-2.5 w-4/6 rounded bg-gray-200" />
        </div>
        <div className="flex w-[42%] flex-col gap-3">
          <div className="h-14 rounded-xl bg-gray-200" />
          <div className="h-14 rounded-xl bg-gray-200" />
        </div>
      </div>
      <div className="h-24 w-full rounded-xl bg-gray-200" />
    </div>
  );
}
